import toast from "react-hot-toast";
import { formatNumber } from "../../utils/utils";

const { clientAPI } = require("../client");
export const serviceFeeCall = {
  create: async (data) => {
    try {
      const response = await clientAPI("post", "/serviceFee", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const response = await clientAPI("put", `/serviceFee/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  delete: async (id) => {
    try {
      const response = await clientAPI("delete", `/serviceFee/${id}`);
      return response;
    } catch (error) {
      console.error("Delete error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  checkCodeUnique: async (code) => {
    try {
      const response = await clientAPI("get", `/serviceFee/code/${code}`);
      if (!response || response?.data) {
        return true;
      }
      return false;
    } catch (error) {
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      return true;
    }
  },
  export: async (entries, param) => {
    try {
      const options = {
        limit: entries,
        page: 1,
      };

      if (param.search) options.search = param.search;
      if (param.month) options.month = param.month;
      if (param.year) options.year = param.year;

      const queryParams = new URLSearchParams(options).toString();
      const response = await clientAPI(
        "get",
        `/commission/listByMonth?${queryParams}`
      );

      const dataExport = response?.items.map((item, index) => {
        const month = item?._id?.month
          ? Number(item?._id?.month) < 10
            ? `0${item?._id?.month}`
            : item?._id?.month
          : "";
        const time =
          item?._id?.month && item?._id?.year
            ? `Tháng ${month}/${item?._id?.year}`
            : "-";
        return {
          time: time,
          code: item?.employee?.code || "-",
          fullName: item?.employee?.fullName || "-",
          jobTitle: item?.jobTitle?.name || "-",
          phone: item?.employee?.phone || "-",
          saleBlock: item?.saleBlock?.name || "-",
          saleArea: item?.saleArea?.name || "-",
          serviceFee: item?.serviceFee
            ? `${formatNumber(Number(item?.serviceFee))} VNĐ`
            : "0 VNĐ",
        };
      });

      return dataExport;
    } catch (error) {
      console.error("get list error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
};
